import React from 'react';
import PropTypes from 'prop-types';
import Reviews from '@fiverr-private/reviews/src/reviews';
import SafePureComponent from '../shared/SafePureComponent';
import { validateReviews } from '../../utils/mainComponentsValidator';
import { DEFAULT_REVIEWS_FILTER } from '../../utils/constants/reviews';
import isInHelpfulReviewsTest from '../../utils/experiments/helpfulReviews';
import { PAGE_NAME } from '../../utils/events';

import './style.scss';

const GIG_PAGE = 'gig_page';

const GigReviews = ({ reviews }, { requestContext }) => {
    // todo: maintain error
    if (!validateReviews({reviews, error: false})) {
        return null;
    }

    const {
        ab_tests: abTests,
        page_ctx_id: pageCtxId,
        is_mobile: isMobile
    } = requestContext;

    const enrichData = {
        pathFinderConfig: {
            path: 'fetch_reviews',
            params: {
                perseus_name: GIG_PAGE,
                gig_id: reviews.gig_id
            }
        },
        pageCtxId,
        pageName: PAGE_NAME,
        type: DEFAULT_REVIEWS_FILTER,
        displayRelevant: true,
        biEventGroup: GIG_PAGE,
        displayBreakdown: !isMobile,
        displayHelpful: isInHelpfulReviewsTest(abTests)
    };

    return (
        <Reviews initialState={({...reviews, ...enrichData})} className="gig-reviews"/>
    );
};

GigReviews.propTypes = {
    reviews: PropTypes.object
};

GigReviews.defaultProps = {
    reviews: {}
};

GigReviews.contextTypes = {
    requestContext: PropTypes.object
};

export { GigReviews };
export default SafePureComponent(GigReviews);
